import React, { ReactElement, ReactNode, useContext } from 'react';
import Styled from './NavLink.styled';
import { ComponentProps } from './NavLink.types';
import Context from '../Context';

const NavLink: React.FC<ComponentProps> = ({ children, isActive, ...props }) => {
  const ctx = useContext(Context);

  return (
    <Styled status={isActive ? 'active' : ''} variant={ctx.variant} {...props}>
      {children}
    </Styled>
  );
};

export default NavLink;
